const DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * 指定された日付文字列から年齢を計算します。
 * @param {string} dateString - 生年月日を表す日付文字列（例: "1990-01-01"）。
 * @returns {number} 計算された年齢。無効な日付文字列が渡された場合はNaNを返します。
 */
export const calculateAge = (dateString: string, today = new Date() // for test
): number => {
  const dateRegex = DATE_REGEX;
  const match = dateString.match(dateRegex);
  if (!match) {
    return NaN;
  }
  const [_, birthYearString, birthMonthString, birthDayString] = match;
  const birthYear = +birthYearString;
  const birthMonth = +birthMonthString;
  const birthDay = +birthDayString;
  if (Number.isNaN(birthYear) || Number.isNaN(birthMonth) || Number.isNaN(birthDay)) {
    return NaN;
  }
  const getFullYear = (date: Date) => date.getFullYear();
  const getMonth = (date: Date) => date.getMonth() + 1;
  const getDate = (date: Date) => date.getDate();
  const currentYear = getFullYear(today);
  const currentMonth = getMonth(today);
  const currentDay = getDate(today);
  const age = currentYear - birthYear;
  const isBirthdayPassed = currentMonth > birthMonth || currentMonth === birthMonth && currentDay >= birthDay;
  return isBirthdayPassed ? age : age - 1;
};